import React, { useState, useEffect, useContext } from "react";
import AuthContext from "../../Context/AuthContext";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import CardPayment from "../Components/CardPayment";
import StripeCardPayment from "../Components/StripeCardPayment";
import { useNavigate, useParams } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { FaPlusCircle } from "react-icons/fa";
import Button from "react-bootstrap/Button";

function CardPayments() {
  const { state } = useContext(AuthContext);
  const [payments, setPayments] = useState([]);
  const [stripeCardPayments, setStripeCardPayments] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  let { rid } = useParams();

  const navigate = useNavigate();

  useEffect(() => {
    async function fetch() {
      const response = await axios({
        method: "get",
        url: `${process.env.REACT_APP_BACKEND_URL}/cardPayments/residence/${rid}`,
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });
      setPayments(
        response.data.cardPayments.sort(
          (a, b) => new Date(b.created_at) - new Date(a.created_at),
        ),
      );
      setStripeCardPayments(response.data.stripeCardPayments);
      setIsLoading(false);
    }
    fetch();
  }, [state.token, rid]);

  if (isLoading) {
    return <Spinner animation="border" />;
  } else {
    return (
      <>
        <Col className="manual-payments">
          <Col className="manual-payments-header">
            <Row className="align-items-center">
              <Col lg={9} className="mb-3">
                <ToastContainer />
                <h4>Pagos con tarjeta registrados</h4>
              </Col>
              {state.role === "root" ? (
                <Col lg={3} className="right icon mb-3">
                  <FaPlusCircle
                    onClick={() => navigate(`/new-card-payment/${rid}`)}
                  />
                </Col>
              ) : (
                <></>
              )}
            </Row>
          </Col>
          {payments.length === 0 ? (
            <Col className="manual-payments-content center">
              <h4>No hay pagos registrados para esta residencia</h4>
            </Col>
          ) : (
            <Col className="manual-payments-content">
              {payments.map((item) => (
                <CardPayment
                  amount={item.amount}
                  date={item.created_at}
                  id={item._id}
                  key={item._id}
                />
              ))}
            </Col>
          )}
        </Col>

        {state.role === "root" ? (
          <Col className="stripe-card-payments">
            <Col className="stripe-card-payments-header">
              <Row className="align-items-center">
                <Col className="mt-3">
                  <ToastContainer />
                  <h4>Pagos stripe</h4>
                </Col>
              </Row>
            </Col>
            <Col className="stripe-card-payments-content">
              {stripeCardPayments.map((item) => (
                <StripeCardPayment
                  id={item._id}
                  totalAmount={item.totalAmount}
                  month={item.month}
                />
              ))}
            </Col>
          </Col>
        ) : (
          <></>
        )}

        <Button
          variant="secondary"
          className="mt-3"
          onClick={() => navigate(`/residence-details/${rid}`)}
        >
          Regresar
        </Button>
      </>
    );
  }
}

export default CardPayments;
